<highcharts-chart
  *ngIf="this.data?.performance?.length||0>0"
  id="container"
  [Highcharts]="Highcharts"
  [constructorType]="'mapChart'"
  [options]="chartOptions">
</highcharts-chart>
<app-loader *ngIf="loading"></app-loader>

<app-no-widget-data *ngIf="!this.data?.performance?.length||0>0 && !loading"></app-no-widget-data>

